import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // 基本
        background: '#FDFAFA',
        font_main: '#534343',
        // メイン見出し
        headline_second: '#534343',
        // ヘッダー
        header_bg: '#FDFFEC',
        header_font: '#1C1C1C',
        // フッター
        footer_bg: '#F1E3D7',
        footer_link: '#534343',
        // ボタン
        btn_main_bg: '#D5686B',
        btn_main_font: '#FFFFFF',
        btn_main_gradation_first: '#E6C406',
        btn_main_gradation_second: '#AF7C0A',
        // 文字サイズ変更ボタン
        change_btn: '#FDFAFA',
        change_btn_invert: '#D5686B',
        // テキストリンク
        link_main: '#3131D0',
        link_sub: '#F7FF39',
        // 鑑定師一覧・詳細
        actor_box_bg: '#F9F5E5',
        actor_box_font: '#000000',
        actor_box_border: '#C4AB65',
        // メールBOX一覧・鑑定ポイント一覧
        menu_list: '#F9F5E5',
        menu_list_font: '#000000',
        // メールBOX見出し
        mail_box_headline: '#F5E7D6',
        mail_box_headline_font: '#534343',
        // 通知バッジ
        badge: '#3B54DD',
        badge_font: '#fff',
        // ポイント表
        table_head: '#F5E7D6',
        table_head_font: '#534343',
        table_body: '#F9F5E5',
        table_body_font: '#212020',
        // 無料占い結果
        horo_result_bg: '#00279E',
        horo_result_gradation_first: '#454393',
        horo_result_gradation_second: '#542D6E',
        horo_result_border: '#815DD4',
        horo_result_font: '#fff',
        // 強調・注意表示部分
        emphasis: '#BE0A0A',
        caution: '#BE0A0A',
        font_annotation: '#fff',
        // その他テキスト
        error: '#BE1528',
        info: '#72BC88',
        success: '#72BC88',
        // 固定ページ
        page_headline: '#1C1C1C',
        page_link: '#3131D0'
      }
    },
    options: { customProperties: true }
  }
})
